import React, {useEffect, useRef} from 'react';
import UseScriptt  from "./useScriptt";

const home = ({text}) => {
 
 
  return (
    <div className=' h-screen w-full'>
 <canvas className="h-screen w-full" id="canvas" >
  <UseScriptt></UseScriptt></canvas>   
   </div>
  );
};

export default home;
